// extracted by mini-css-extract-plugin
module.exports = {"body":"layout-module--body--1ZXSH","footer":"layout-module--footer--1hz3q"};